import { render, staticRenderFns } from "./textItem.vue?vue&type=template&id=d6665eca&scoped=true"
import script from "./textItem.vue?vue&type=script&lang=js"
export * from "./textItem.vue?vue&type=script&lang=js"
import style0 from "./textItem.vue?vue&type=style&index=0&id=d6665eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6665eca",
  null
  
)

export default component.exports